// @flow
import _ from 'lodash';

import AppDispatcher from 'PMT/flux/AppDispatcher';

import ActionTypes from 'constants/ActionTypes';

import PMTApiProAccount from 'PMT/api/ApiProAccount';

import ProAccountStore from 'stores/ProAccountStore';

import ApiError from 'PMT/entities/ApiError';
import {
  ProRole,
} from 'PMT/entities/security';

export default class SecurityAction {

  //
  // Get Pro Role with elevation code
  //

  static getPrivilegeRoleWithElevationCode(elevationCode: string) {
    let domainId = null;
    const domain = ProAccountStore.getSelectedProDomain();
    if (!_.isNull(domain)) {
      domainId = domain.id;
    }

    PMTApiProAccount.getProRoleWithElevationCode(
      domainId,
      elevationCode,
      SecurityAction.receivePrivilegeRoleWithCode,
      SecurityAction.receivePrivilegeRoleWithCodeError
    );
  }

  static receivePrivilegeRoleWithCode(proRole: ProRole, elevationCode: string) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PRO_ROLE_WITH_ELEVATION_CODE_SUCCESS,
      proRole,
      elevationCode
    });
  }

  static receivePrivilegeRoleWithCodeError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PRO_ROLE_WITH_ELEVATION_CODE_FAILURE,
      apiError
    });
  }

}



// WEBPACK FOOTER //
// ./scripts/actions/SecurityAction.js